import { render, staticRenderFns } from "./FiltersSidebar.vue?vue&type=template&id=4c64d659&scoped=true"
import script from "./FiltersSidebar.vue?vue&type=script&lang=js"
export * from "./FiltersSidebar.vue?vue&type=script&lang=js"
import style0 from "./FiltersSidebar.vue?vue&type=style&index=0&id=4c64d659&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c64d659",
  null
  
)

export default component.exports